export interface InventorySourceLocation { id: string; name: string }

export const TOKYO_REPLENISHMENT_REQUESTER_EMAILS = ["jiyugaoka_tokyo@tweed.jp", "app-admin@tweed.co.jp"] as const;

export function inventoryLocationForCity(locations: readonly InventorySourceLocation[], city: string): InventorySourceLocation | undefined {
  const name = (location: InventorySourceLocation) => location.name.normalize("NFKC").trim();
  return locations.find((location) => name(location) === city)
    ?? locations.find((location) => name(location).startsWith(city))
    ?? locations.find((location) => name(location).includes(city));
}

export function defaultInventorySourceLocation(locations: readonly InventorySourceLocation[]): InventorySourceLocation | undefined {
  return inventoryLocationForCity(locations, "大阪");
}

export function defaultInventoryReplenishmentLocation(locations: readonly InventorySourceLocation[], requesterEmail: string): InventorySourceLocation | undefined {
  return TOKYO_REPLENISHMENT_REQUESTER_EMAILS.some((email) => email === requesterEmail.trim().toLowerCase())
    ? inventoryLocationForCity(locations, "東京") : undefined;
}
